var React = require('react');

function Exclamation (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_338","data-name":"Path 338","d":"M11,15h2v2H11Zm0-8h2v6H11Zm.99-5A10,10,0,1,0,22,12,10,10,0,0,0,11.99,2ZM12,20a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z","transform":"translate(-2 -2)","fill":"#e69575"}));
}

Exclamation.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = Exclamation;

Exclamation.default = Exclamation;
